import './index.scss'
 var $text = $('.section1 h2');
var maxScroll = $('.nei-banner').height() + $(".section1").height() - $(window).height();

$(window).scroll(function() {
    var scrollPercent = $(window).scrollTop() / maxScroll;
    var position = 100 - (scrollPercent * 20);
    
    $text.css('background-position', position + '% 0');
});

$(".section2 .right .pic").eq(0).addClass("active");
$(".section2 ul li").hover(function() {
  let index = $(this).index();
  $(".section2 .right .pic").eq(index).addClass('active').siblings().removeClass('active');
})


$(".solution-nav li").eq(0).addClass("active");
$(".solution-list ul").eq(0).addClass("active");
$(".solution-nav li").click(function() {
  let index = $(this).index();
  $(this).addClass('active').siblings().removeClass('active');
  $(".solution-list ul").eq(index).addClass('active').siblings().removeClass('active');
})
